<template>
  <div class="p-4 md:p-3 rounded-lg">
    <div class="text-card text-sm font-normal leading-5 text-gray-600">
      <p v-html="replaceWithBr(props.item.text)"></p>
    </div>
  </div>
</template>

<script setup>
import { useHeaderStore } from '@/stores'

const headerStore = useHeaderStore()

const props = defineProps(['item'])

function replaceWithBr(text) {
  return text.replace(/\n/g, "<br />")
}

</script>
